import React from "react";
import { Grid } from '@mui/material'
import { Outlet } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import TopBar from "./TopBar";
import Footer from "./Footer";
import ErrorModule from "./ErrorModule";

const ErrorPage = () => {
    const location = useLocation()
    return (
        <Grid container sx={{ height: "100vh" }}>
            <Grid item xs={12} >
                <Header />
            </Grid>
            <Grid item xs={12}>
                <TopBar />
            </Grid>
            <Grid item xs={12} sx={{ height: "calc(100vh - 21vh)", overflowY: location.pathname == '/app/Analytics' ? "scroll" : location.pathname == '/app/Reports' ? "scroll" : "hidden" }}>
                <ErrorModule/>
            </Grid>
            <Grid item xs={12}>
                <Footer />
            </Grid>
        </Grid>
    );
};

export default ErrorPage;
